import React from "react";
import styles from "./tooltip.module.scss";

interface TooltipProps {
  children?: any;
  title?: string;
}

export const Tooltip: React.FC<TooltipProps> = ({  
  title,
  children
}) => {
  return (
    <div className={styles.tooltip}>
      <span className={styles.tooltip__title}>{title}</span>
      {children}
    </div>
  );
};
